import { COMPANY_INITIALS, COMPANY_LOCATION, COMPANY_NAME, COMPANY_SHORT } from '../constants';

function Footer() {
  return (
    <footer className="bg-paper">
      <div className="mx-auto flex max-w-6xl flex-col gap-4 px-6 py-10 text-sm text-muted md:flex-row md:items-center md:justify-between">
        <div className="flex items-center gap-3">
          <span className="grid h-9 w-9 place-items-center rounded-lg bg-ink text-xs font-black text-cyan">
            {COMPANY_INITIALS}
          </span>
          <p className="text-lg font-black text-ink">{COMPANY_SHORT}</p>
        </div>
        <p>&copy; {new Date().getFullYear()} {COMPANY_NAME}</p>
        <p>{COMPANY_LOCATION}</p>
      </div>
    </footer>
  );
}

export default Footer;
